import { render, staticRenderFns } from "./RevealPage.vue?vue&type=template&id=562aa250&scoped=true&"
import script from "./RevealPage.vue?vue&type=script&lang=js&"
export * from "./RevealPage.vue?vue&type=script&lang=js&"
import style0 from "./RevealPage.vue?vue&type=style&index=0&id=562aa250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562aa250",
  null
  
)

export default component.exports